import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight, faXmark } from '@fortawesome/free-solid-svg-icons'

import ButtonCustom from '../../../../../../../../../../Components/ButtonCustom'
import { Warning } from '../../../../../../../../../../Components/CustomUi/warning'
import { FooterTrocaLab } from './styled'
import type { AnaliseAdicionada } from '../../types'

interface Props {
  abrir: boolean
  /** Análises que o laboratório recém-selecionado não oferece. */
  analises_nao_encontradas: AnaliseAdicionada[]
  /** Mantém a troca e descarta as análises listadas. */
  aoConfirmar: () => void
  /** Desfaz a troca, voltando ao laboratório anterior. */
  aoCancelar: () => void
}

/**
 * Trocar o laboratório de uma OS reprecifica as análises pela tabela do novo
 * laboratório. As que ele não oferece não têm preço — este modal pede ao usuário
 * que decida entre descartá-las ou desfazer a troca.
 * Portado da versão em produção (`ordemLaboratorio/index.tsx:2106-2144`).
 */
export const ConfirmarTrocaLab: React.FC<Props> = ({
  abrir,
  analises_nao_encontradas,
  aoConfirmar,
  aoCancelar,
}) => {
  return (
    <Modal
      open={abrir}
      onCancel={aoCancelar}
      title='Análises não encontradas'
      width={700}
      footer={false}
      destroyOnClose
      zIndex={9999}
    >
      As análises listadas abaixo não foram encontradas no cadastro do laboratório informado.{' '}
      <b>Deseja descartá-las e prosseguir apenas com as análises cadastradas?</b>

      {(analises_nao_encontradas ?? []).map((item, index) => (
        <Warning type='error' style={{ margin: '5px 0px' }} key={`${item?.id}-${index}`}>
          {item?.analise_nome} ({item?.profundidade})
        </Warning>
      ))}

      <FooterTrocaLab>
        <ButtonCustom
          onClick={aoCancelar}
          type='secondary'
          danger
          icon={<FontAwesomeIcon icon={faXmark} />}
        >
          Cancelar
        </ButtonCustom>
        <ButtonCustom
          onClick={aoConfirmar}
          type='primary'
          icon={<FontAwesomeIcon icon={faArrowCircleRight} />}
        >
          Descartar e prosseguir
        </ButtonCustom>
      </FooterTrocaLab>
    </Modal>
  )
}
